export default __webpack_public_path__ + "static/media/eye-icon.8a98b9be.svg";